jQuery(document).ready(function() {

  jQuery(".image-with-text-split__image-container").append(jQuery(".image-with-text-split__text-container .image-block"));

  jQuery("button.bundle-option").on("click", function() {
    
  jQuery("button.bundle-option").removeClass("active");

  jQuery(this).addClass("active");

  console.log("Bundle option clicked!");
});

  jQuery("button.bundle-option:first-child").addClass("active");

  var bundleHeader = `<div class="bundle-header">
      <h2 class="bundle-header-cont">Choose Your Pack</h2>
  </div>`
  
  jQuery(".bundle-options").before(bundleHeader);



  $('[href="#product-form"]').click(function(e){
  e.preventDefault();
    document.querySelector('.main-product-section').scrollIntoView({
    behavior: 'smooth',
    block: 'start' // You can use 'center', 'end', or 'nearest' depending on your needs
});
}); 
function isElementPartiallyVisible(selector) {
  const el = document.querySelector(selector);
  if (!el) return false;

  const rect = el.getBoundingClientRect();

  return (
    rect.top < window.innerHeight &&
    rect.bottom > 0
  );
}

jQuery(document).on('scroll', function () {
  if (isElementPartiallyVisible('.main-product-section')) {
    console.log('here');
    jQuery('body').addClass('main-visible');
  } else {
    jQuery('body').removeClass('main-visible');
  }
});

// Example usage:


});